var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFooterLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 72,
    viewBox: "0 0 76 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_531_1194)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0601 48.3311V61.8987C22.0601 63.6153 22.2612 65.0017 22.6635 66.0579C23.0076 67.0394 23.6351 67.9 24.4686 68.5335C25.3465 69.1621 26.3573 69.5858 27.425 69.7726C28.7682 70.0184 30.1325 70.134 31.4984 70.1177C33.0744 70.1162 34.6487 70.0176 36.2123 69.8223C37.3876 69.697 38.5536 69.498 39.7033 69.2263V48.3311H22.0601Z",
    fill: "#00BBF4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0597 30.999H8.32302C6.58498 30.999 5.18132 31.1968 4.11203 31.5924C3.11922 31.9342 2.24841 32.5536 1.60555 33.3753C0.971054 34.2442 0.543131 35.2432 0.353632 36.298C0.103185 37.62 -0.0147242 38.9632 0.0016137 40.3081C0.00401675 41.8648 0.104789 43.4198 0.303344 44.964C0.427706 46.1311 0.628397 47.2889 0.904158 48.4304H22.0597V30.999Z",
    fill: "#FAA727"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6081 16.9348C39.6081 15.2199 39.4078 13.8335 39.0072 12.7756C38.6612 11.7951 38.0341 10.935 37.2022 10.3C36.3221 9.67349 35.3109 9.25004 34.2431 9.06088C32.9017 8.8154 31.5392 8.69983 30.175 8.71581C28.6335 8.72155 27.0944 8.83687 25.5697 9.06088C23.9657 9.29442 22.7959 9.47654 22.0601 9.60725V30.8998H39.6081V16.9348Z",
    fill: "#B122EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.7436 56.6494C69.1062 54.9345 67.4184 53.135 65.6804 51.2511C63.9424 49.3671 62.1708 47.4692 60.3657 45.5574C58.5606 43.6403 56.8226 41.7589 55.1516 39.9133L67.6866 27.5325C69.6276 25.6154 71.0313 23.8988 71.8976 22.3826C72.7555 20.9061 73.2054 19.2329 73.2025 17.5306C73.2025 15.2197 72.2161 13.2224 70.2434 11.5389C68.2707 9.85537 65.0117 9.01273 60.4663 9.01099L39.6099 30.8996L39.7104 48.331L53.8494 63.5822C55.3579 65.3405 57.0369 66.9489 58.8624 68.3845C60.6004 69.7386 62.8395 70.4157 65.5798 70.4157C66.8086 70.422 68.0295 70.2213 69.19 69.8223C70.3214 69.4316 71.3644 68.8259 72.2602 68.0394C73.1703 67.2368 73.9036 66.258 74.4147 65.1638C74.9658 63.9508 75.2371 62.6319 75.2087 61.3026C73.8695 59.9171 72.3811 58.366 70.7436 56.6494Z",
    fill: "#4A155F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_531_1194"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 75.8919,
    height: 72,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterLogo);
export default __webpack_public_path__ + "static/media/footer_logo.4091530e72821f6fe741e650e126475b.svg";
export { ForwardRef as ReactComponent };